import { t } from "@lingui/macro";
import React from "react";

import { Button } from "../../controls";
import { StatusWarningIcon } from "../../icons_v2/general";
import { Box, HStack, Text } from "../../primitive";

type ActionHandler = {
  label: string;
  handler: () => void;
};

export type GlobalBannerWarningMessage = {
  message: string;
  actionHandler?: ActionHandler | null;
};

type GlobalWarningBannerProps = {
  warningMessage: GlobalBannerWarningMessage;
  setWarningMessage: React.Dispatch<GlobalBannerWarningMessage | null>;
};

export const GlobalWarningBanner = ({
  warningMessage,
}: GlobalWarningBannerProps) => {
  return (
    <Box padding={2}>
      <HStack
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="surface-status-error-subtle"
        paddingHorizontal={6}
        paddingVertical={2}
        borderRadius="2"
      >
        <HStack gap={3}>
          <StatusWarningIcon />
          <Text variant="mainBaseSemiBold">{t`${warningMessage.message}`}</Text>
        </HStack>
        {!!warningMessage?.actionHandler ? (
          <Button
            variant="secondary"
            size="small"
            accessibilityLabel={t`Fix Now`}
            testID="fix-now-button"
          >
            <Text
              variant="mainTiny"
              onPress={() => {
                warningMessage.actionHandler?.handler();
              }}
            >{t`${
              warningMessage?.actionHandler?.label
                ? warningMessage.actionHandler.label
                : t`Fix Now`
            }`}</Text>
          </Button>
        ) : null}
      </HStack>
    </Box>
  );
};
